import { LinkObject } from "@teamprevent/common/model";
import * as moment from "moment";

export enum DataExtractStatus {
    Queued = "Queued",
    Processing = "Processing",
    Completed = "Completed",
    PartiallyCompleted = "Partially Completed"
}

export interface DataExtract {
    id: string;
    status: DataExtractStatus;
    customer: LinkObject;
    employeeRecord?: LinkObject;
    dateCreated: moment.Moment;
}

export const parseDataExtractModel = (dataExtract: DataExtract) => ({
    ...dataExtract,
    dateCreated: moment(dataExtract.dateCreated)
});
